import axios from "axios";
  import store from "../../store/index";
  import moment from "moment";
  import VPagination from "@hennge/vue3-pagination";
  import "@hennge/vue3-pagination/dist/vue3-pagination.css";

  export default {
    name: "Macro_Management",
    components: {
      VPagination,
    },
    data() {
      return {
        baseurl: process.env.VUE_APP_Service_URL,
        enableNext: true,
        enablePrevious: true,
        currentPageSize: 0,
        currentPageNumber: 1,
        totalItems: 0,
        totalPages: 0,
        studyId: "",
        versionList:[],
        pageSize: 10,
        currentPage: 1,
        searchData: {
         searchMacroName:"",
          pageSize: 0,
          pageNumber: 0,
        },
  
        requestData: {
          pageSize: 0,
          pageNumber: 0,
          
        },
        
        sortDesc: "",
        SortOrder: "desc",
        SortProperty: "createdAt",
        MetaDataList: [],
      };
    },
    async mounted() {
      this.defaultdate = localStorage.getItem("dateformat");
      await this.getVersion();
      this.GetMetaDataList();        
      this.filter();
      window.addEventListener("studyIdChanged", async (event) => {
        await this.getVersion();
        this.GetMetaDataList();
      });
    },
    methods: {
      async gotTo(type,id){
        if(type=='stats'){
          this.$router.push(`/stats/0/0`)
        }
        else if(type=='delete'){
          const idtoken = store.getters.getIdToken;
          if(confirm(this.$t('navigations.are you sure you want to delete this macro')))
          await axios
            .delete(
              `${this.baseurl}/stats-python/macro/deletemacro/${id}`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              console.log(res);
              alert(this.$t('navigations.macro deleted succesfully'))
              this.GetMetaDataList();    
            })
            .catch((err) => {
              alert("Network error")
              console.log(err);
            });
        }
        else {
          this.$router.push(`/stats/${id}/1`)
        }
      },
      filter(data) {
          if (data) {
            return moment(data).format(this.defaultdate);
          }
          console.log("Reverse is");
          console.log(data);
        },
      // async searchAndGetData() {
      //   const idtoken = store.getters.getIdToken;
      //   if (this.activeValue === "TRUE") {
      //     this.requestData.searchActive = true;
      //   } else if (this.activeValue === "FALSE") {
      //     this.requestData.searchActive = false;
      //   } else {
      //     this.requestData.searchActive = null;
      //   }
      //   if (this.lockedValue === "TRUE") {
      //     this.requestData.searchLocked = true;
      //   } else if (this.lockedValue === "FALSE") {
      //     this.requestData.searchLocked = false;
      //   } else {
      //     this.requestData.searchLocked = null;
      //   }
      //   if (this.requestData.searchRole === "All") {
      //     this.requestData.searchRole = "";
      //   }
      //   console.log(this.requestData);
      //   console.log("users listed");
      //   await axios
      //     .get(
      //       `${this.baseurl}/account-core/user/userlist?Key=${this.requestData.searchEmail}&Role=${this.requestData.searchRole}&pageindex=${this.requestData.pageNumber}&pagesize=10&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
      //       {
      //         headers: {
      //           Authorization: "Bearer " + idtoken,
      //           "Content-Type": "application/json",
      //         },
      //       }
      //     )
      //     .then((res) => {
      //       console.log(res);
      //       if (res.data.data === "No User Found.") {
      //         alert("No Users Were Found.");
      //         this.userList = [];
      //         this.enableNext = false;
      //       } else {
      //         console.log("users data");
      //         this.userList = res.data.results;
      //         console.log(res.data.results);
      //         this.totalIteems = res.data.totalCount;
      //         this.totalPages =
      //           Math.trunc(this.totalIteems / 10) < 1
      //             ? 1
      //             : this.totalIteems / 10 > Math.trunc(this.totalIteems / 10)
      //             ? Math.trunc(this.totalIteems / 10) + 1
      //             : Math.trunc(this.totalIteems / 10);
      //         this.enableNext = this.currentPageNumber !== this.totalPages;
      //         this.enablePrevious = this.currentPageNumber !== 1;
      //       }
      //       this.totalIteems = res.data.totalCount;
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //       this.enableNext = false;
      //       this.enablePrevious = false;
      //     });
      // },
    loadPage: function(page) {
      this.currentPage = page;
      this.pageIndex = page;
      this.GetMetaDataList();
    },

    async GetMetaDataList() {
        const idtoken = store.getters.getIdToken;
        const page = this.currentPage || 1;
        const pageSize = this.pageSize || 10;
        const sortBy = this.SortProperty || "createdAt";
        const sortOrder = this.SortOrder;
        const versionParam = this.interimVersion ? this.interimVersion : this.versionList[0];
        this.studyId = store.getters.getStudyIs;
        await axios
          .get(
            `${this.baseurl}/stats-python/report/getreportbystudyversion`,
            {
            params: {
              PageNumber: page,
              PageSize: pageSize,
              SortBy: sortBy,
              SortOrder: sortOrder,
              InterimVersion: versionParam,
              StudyId: this.studyId,
              TypeName: "currentstatusentryreport",
            },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
          )
          .then((res) => {
            console.log(res);
            this.MetaDataList = res.data.Data;
            this.totalItems = Math.ceil(res.data.Total / this.pageSize);
            console.log(" this.totalItems.......:", this.totalItems);
            console.log("Data",this.MetaDataList);
          })
          .catch((err) => {
            console.log(err);
            this.enableNext = false;
            this.enablePrevious = false;
          });
    },
    SearchMacroByName() {
      const idtoken = store.getters.getIdToken;
      const versionParam = this.interimVersion ? this.interimVersion : this.versionList[0];
      this.studyId = store.getters.getStudyIs;
      console.log("asdasdsddddd:", this.searchData.searchMacroName);
      axios
        .get(
          `${this.baseurl}/stats-python/report/getreportbystudyversion?InterimVersion=${versionParam}&StudyId=${this.studyId}&ReportName=${this.searchData.searchMacroName}&TypeName=currentstatusentryreport`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.MetaDataList = res.data.Data;
          console.log("Searched MacroList:", this.MetaDataList);
        })
        .catch((err) => {
          console.error("Search Macro error:", err);
        });
    },
    async getVersion(){
        const idtoken = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
         await axios.get(
          `${this.baseurl}/forms/cdisc/listinterimversions?studyId=${this.studyId}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        ).then((res)=>{
            this.versionList = res.data
            if (this.versionList.length > 1) {
                this.interimVersion = this.versionList[0];
              }
        }).catch((err)=>{
          console.log("err",err)
        })
      }
    
    },
  };